'use client';

import { useEffect, useState } from 'react';

/** Ported as-is from scripts.js banner 7 — delayed .active class, 2200ms. */
export default function ScrollIndicator() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setActive(true), 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`scroll-indicator${active ? ' active' : ''}`} id="scroller">
      <div className="scroll-line" />
    </div>
  );
}
